<template>
  <div ref="tsContainer" class="turnstile-container"></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { loadScript } from "@/composables/useLoadScript.js";

const props = defineProps({
  siteKey: { type: String, required: true },
  theme: {
    type: String,
    default: "light",
    validator: v => ["light", "dark", "auto"].includes(v),
  },
  size: {
    type: String,
    default: "flexible",
    validator: v => ["normal", "compact", "flexible"].includes(v),
  },
});

const emit = defineEmits(["success", "error"]);
const tsContainer = ref(null);

onMounted(async () => {
  // 1) load the Turnstile script
  try {
    await loadScript("https://challenges.cloudflare.com/turnstile/v0/api.js");
  } catch (err) {
    console.error("Could not load Turnstile:", err);
    emit("error");
    return;
  }

  // 2) pick your size
  let finalSize = props.size;
  if (props.size === "flexible") {
    finalSize = window.innerWidth <= 640 ? "compact" : "normal";
  }

  console.log({
    hasTurnstile: !!window.turnstile,
    containerEl: tsContainer.value,
    usingSize: finalSize,
  });

  if (!window.turnstile || !tsContainer.value) {
    emit("error");
    return;
  }

  // 3) render it
  window.turnstile.render(tsContainer.value, {
    sitekey: props.siteKey,
    theme:   props.theme,
    size:    finalSize,
    callback(token) {
      emit("success", token);
    },
    "error-callback"() {
      emit("error");
    },
  });
});
</script>

<style scoped>
.turnstile-container {
  width: 100%;
  /* no height override! let the widget set its own height */
}

/* force full‐width only */
.turnstile-container ::v-deep .cf-turnstile,
.turnstile-container ::v-deep .cf-turnstile > div,
.turnstile-container ::v-deep .cf-turnstile iframe {
  width: 100% !important;
}
</style>
